import React from "react";
import { Box } from "@mui/material";

import { ReactComponent as FolderIcon } from "../../../assets/icons/folder.svg";
import { useFoldersSelect } from "store";
import { IFolder } from "store/types";

interface IFolderItem {
  folder: IFolder;
  setIsOpen: (value: boolean) => void;
  sendData: (sectionId: number) => void;
  subFolder: number;
}

export const FolderItem: React.FC<IFolderItem> = ({ folder, setIsOpen, sendData, subFolder }) => {
  const subFolders = useFoldersSelect({ parent_id: folder.id });

  return (
    <>
      <div
        style={{ paddingLeft: `${subFolder * 35}px` }}
        className="move-to-folder flex-row-fs-fc"
        onClick={() => {
          sendData(folder.id);
          setIsOpen(false);
        }}
      >
        <FolderIcon className="move-to-folder__icon" />
        <span className="move-to-folder__title">{folder.title}</span>
      </div>
      {subFolders &&
        subFolders.map((child: IFolder) => (
          <Box key={child.id}>
            <FolderItem
              key={folder.id}
              folder={child}
              setIsOpen={setIsOpen}
              sendData={sendData}
              subFolder={subFolder + 1}
            />
          </Box>
        ))}
    </>
  );
};
